import React from "react";
import { Logo } from "./logo"

function EntryLayout(props) {
    return(
    <div className="container-scroller">
        <div className="container-fluid page-body-wrapper full-page-wrapper">
            <div className="content-wrapper d-flex align-items-stretch auth auth-img-bg">
                <div className="row flex-grow">
                    <div className="col-lg-6 d-flex align-items-center justify-content-center">
                        <div className="auth-form-transparent text-left p-3">
                            <Logo />
                            {props.children}
                        </div>
                    </div>
                    <div className="col-lg-6 register-half-bg d-flex flex-row">
                        <p className="text-white font-weight-medium text-center flex-grow align-self-end">&copy; cvalenciait.com</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export { EntryLayout }